export default __webpack_public_path__ + "static/media/Tick.ee9aa5dd.svg";